import {decodeOrThrow} from '@raison/io-ts-tools';
import {isErroneousServerResult, Jwt, RefreshToken} from '@raison/network-facade';
import {MobilePhone, NonEmptyString, Password, PositiveInt} from '@raison/types';
import {Either, left, right} from 'fp-ts/lib/Either';
import {array, readonly, type, TypeOf} from 'io-ts';
import {apiPost} from '~/shared/utils/api_legacy';
import {LegacyAddressStatus} from '../model/AddressStatus';
import {UserId} from '../model/UserId';
import {UserStatusIoTs} from '../model/UserStatus';

export interface LoginRequestData {
    readonly username: MobilePhone;
    readonly password: Password;
    readonly onesignal_id?: NonEmptyString;
    readonly onesignal_consent?: boolean;
}

export const LoginResponseData = readonly(
    type({
        access_token: Jwt,
        expires_in: PositiveInt,
        refresh_token: RefreshToken,
        refresh_token_expiration: PositiveInt,
        user: readonly(
            type({
                id: UserId,
                username: MobilePhone,
                status: UserStatusIoTs,
                roles: readonly(array(NonEmptyString)),
                address_status: LegacyAddressStatus,
            })
        ),
    })
);
export type LoginResponseData = TypeOf<typeof LoginResponseData>;

export const login = async (
    userCredentials: LoginRequestData
): Promise<Either<{type: string | undefined; error: unknown}, LoginResponseData>> => {
    try {
        const data = await apiPost('/api/v1/sign_in', {data: userCredentials});
        return right(decodeOrThrow(LoginResponseData, data));
    } catch (error) {
        if (isErroneousServerResult(error)) {
            return left({type: 'ApiClientError', error});
        }
        return left({type: undefined, error});
    }
};
